import React from 'react'
import DriverSection1 from './DriverSection1'
import DriverSection2 from './DriverSection2'
import DriverSection3 from './DriverSection3'
import DriverSection4 from './DriverSection4'
import Navbar from '../LandingPage/Navbar'
import Footer from '../LandingPage/Footer'
import FAQ from './FAQ'

const DriverPartnerMain = () => {
  return (
    <>
    <Navbar/>
    <DriverSection1/>
    <DriverSection2/>
    <DriverSection3/>
    <DriverSection4/>
    <FAQ/>
    <Footer/>
    </>
  )
}

export default DriverPartnerMain
